// extracted by mini-css-extract-plugin
module.exports = {"container":"error_p_container__UNyy3"};